/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          :  OrderHistory.tsx
*
* Project Title :  Checkout
*
* Description   : Order History Page
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : H422336
*
* @Date         : Oct 23 2020
*
* @Version      : Version 1.0
*
* By            : H422336
* On            : Nov, 5 2020
* Description   : ASDS-4016 UI Enhancements for Phase-II
*
* By            : H422337
* On            : Nov, 19 2020
* Description   : ASDS-4083 UI Enhancements for Phase-II  bug fix & Delete All  products from the cart
*
******************************************************************************/

import * as React from 'react';
import { Grid, Notification } from '@scuf/common';
import '@scuf/common/honeywell/theme.css';
import '@scuf/styles/variables.scss';
import './OrderHistory.css';
import { connect } from 'react-redux';
import Layout from '../Layout/Layout';
import HistoryTable from './HistoryTable';
import GenericLoader from '../Loader/Loader';
import OrderHistoryActions from '../redux/actions/order-history-actions';
import CartDetailsActions from '../redux/actions/cart-details-actions';
import NonMSAPOProductsDeleteNotification from '../Notifications/NonMSAPOProductsDeleteNotification';
import { CheckoutUILabels } from '../constants/checkout-constants';
import { ContactUsMessage } from '../Common/ContactUsMessage';

interface IOrderHistoryState {
}

interface IOrderHistoryProps {
    isFetching: boolean;
    isSuccess: boolean;
    orders: [];
    soldTos: any;
    getOrderHistory: Function;
    setSoldToOptions: Function;
    deleteAllProductsSuccessFlag: boolean;
    notify: string;
    updatedeleteAllProductsSuccessFlag: Function;
}

const ReactToastify =  require('react-toastify');

class OrderHistory extends React.Component<IOrderHistoryProps, IOrderHistoryState> {
    componentDidMount() {
       this.getOrderHistory();
    }

    async getOrderHistory() {
        await this.props.setSoldToOptions();
        let soldToObj = this.props.soldTos.join(',');
        this.props.getOrderHistory(soldToObj);
    }

    deleteAllProductNotify() {
        if (this.props.deleteAllProductsSuccessFlag) {
       ReactToastify.toast(<NonMSAPOProductsDeleteNotification  closeToast={false} msgTitle={CheckoutUILabels.PRODUCT_PRICE_UPDATE} msgBody={CheckoutUILabels.DELETE_ALL_MSA_PRODUCT} />);

      }
   }

    render() {
        if (this.props.deleteAllProductsSuccessFlag) {
            this.deleteAllProductNotify();
            setTimeout(() =>{ this.props.updatedeleteAllProductsSuccessFlag(false)}, 500);

        }
        return (
            <Layout>
                {this.props.isFetching && <GenericLoader text="Fetching Your Order History" className="order-history-loader" loading={true} overlayColor="rgb(247, 247, 247)" />}
                {!this.props.isFetching && !this.props.isSuccess &&
                    <Grid.Column width={12} className="fullwidthRow order-history-page" >
                        <Grid>
                            <Grid.Row className="fullwidthRow">
                                <Notification
                                    severity="critical"
                                    hasIcon={true}
                                    title="There is an error in processing your request."
                                    detailsText="Back to Order History"
                                    onDetailsClick={() => {this.getOrderHistory(); }}
                                >
                                    <b>Oops, Something went wrong.</b>
                                    <br />
                                    <br />
                                    <div>
                                    <ContactUsMessage >
                                        The server encountered an internal error or misconfiguration and was unable to complete your request.
                                    <br />
                                    Please try again after sometime. If the issue persists,
                                    </ContactUsMessage>
                                    </div>
                                </Notification>
                            </Grid.Row>
                        </Grid>
                    </Grid.Column>
                }
                {this.props.isFetching && <Grid.Row>
                    <Grid.Column width={12} className="fullwidthRow order-history-page" >
                        <Grid>
                            <Grid.Row className="fullwidthRow">
                                <Grid.Column width={12}>
                                    <h1 className="centerAlign pageHeading">Order History</h1>
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column width={12}>
                                    <HistoryTable orders={[]}/>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Grid.Column>
                </Grid.Row>}
                {!this.props.isFetching && this.props.isSuccess &&
                <Grid.Row>
                    <Grid.Column width={12} className="fullwidthRow order-history-page" >
                        <Grid>
                            <Grid.Row className="fullwidthRow">
                                <Grid.Column width={12}>
                                    <h1 className="centerAlign pageHeading">Order History</h1>
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column width={12}>
                                    {this.props.isSuccess && <HistoryTable orders={this.props.orders}/>}
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Grid.Column>
                </Grid.Row>
                }
                <Grid.Row>
                    <Grid.Column width={12}>
                        <div>
                        <ReactToastify.ToastContainer
                            hideProgressBar={true}
                            closeOnClick={false}
                            closeButton={false}
                            newestOnTop={true}
                            position={this.props.notify}
                            toastClassName={'toast-notification-wrap' + (this.props.notify === 'top-right' ? ' product-price' : '')}
                        />
                        </div>
                    </Grid.Column>
                </Grid.Row>
            </Layout>
        );
    }
}

function mapStateToProps(state) {
  return {
    isFetching: state.orderHistoryData.payload.isFetching,
    isSuccess: state.orderHistoryData.payload.isSuccess,
    orders: state.orderHistoryData.orders,
    soldTos: state.orderHistoryData.soldTos,
    deleteAllProductsSuccessFlag: state.cartDetails.deleteAllProductsSuccessFlag,
    notify: state.cartDetails.notify
  };
}

const mapDispatchToProps = {
    getOrderHistory: OrderHistoryActions.getOrderHistory,
    setSoldToOptions: OrderHistoryActions.getUserSoldToNumbers,
    updatedeleteAllProductsSuccessFlag: CartDetailsActions.updatedeleteAllProductsSuccessFlag
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderHistory);
